<template>
    <div class="versionsSet">
        <h1>版本管理</h1>
        <div class="versionsTable">
            <div class="btns">
                <span>游戏有且仅有一个启用的版本为当前使用版本，其余版本主要用于历史数据重新算分。请谨慎修改</span>
                <a-button type="primary" @click="openModal()" icon="plus">添加版本
                </a-button>
            </div>
            <a-table :columns="versionscolumns"
                     row-key="id"
                     :loading="tableLoading"
                     :data-source="data"
                     class="components-table-demo-nested">
                <div slot="version" slot-scope="text, record">
                    <div class="table_div">
                        <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0 && currentEnabled == 'true' && text.enabled"/>
                        {{text.version }}
                    </div>
                </div>
                <div slot="status" slot-scope="text, record">
                    <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled"
                              @click="StatusChange(record)"/>
                </div>
                <div slot="action" slot-scope="text, record">
                    <a @click="editModal(record)">
                        <a-icon type="edit"/>
                        编辑</a>
                    <a-popconfirm title="确定删除？" ok-text="确定"
                                  cancel-text="取消" @confirm="deleteVersion(record)" style="margin-left: 15px">
                        <a style="color: #f00;">
                            <a-icon type="delete"/>
                            删除
                        </a>
                    </a-popconfirm>
                </div>
            </a-table>
        </div>
        <!-- 编辑添加版本 -->
        <a-modal v-model="isVersions" :title="versionsTit" @ok="VersionsOk">
            <a-form-model
                ref="ruleForm"
                :model="versionsForm"
                :rules="versionsRules"
                :label-col="{span:6}"
                :wrapper-col="{span:14}"
            >
                <a-form-model-item ref="version" label="游戏版本" prop="version">
                    <a-input v-model.trim="versionsForm.version"/>
                </a-form-model-item>
                <a-form-model-item ref="uri" label="游戏地址" prop="uri">
                    <a-input v-model.trim="versionsForm.uri"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
const versionscolumns = [
    {title: "游戏版本",scopedSlots: {customRender: "version"}, key: "version"},
    {title: "游戏地址", dataIndex: "uri", key: "uri"},
    {title: "创建时间", dataIndex: "createTime", key: "createTime", align: 'center'},
    {title: "状态", scopedSlots: {customRender: "status"}, key: "enabled", align: 'center'},
    {title: "操作", key: "action", scopedSlots: {customRender: "action"}, align: 'center'}
];
export default {
    name: "versionsSet",
    data() {
        return {
            type: '',//添加、编辑
            data: [],//版本数据
            isVersions: false,//是否编辑添加版本
            tableLoading: false,
            versionscolumns,
            // 编辑添加版本表单
            versionsForm: {
                contentId: this.$store.getters["content/getTrainGameInfo"]().id,//当前游戏id
                version: '',//版本号
                uri: '',//地址url
                enabled: false,//状态
                remark: '',//备注
            },
            // 编辑添加版本表单校验规则
            versionsRules: {
                version: [
                    {required: true, message: '请填写游戏版本', trigger: 'blur'},
                    {max: 30, message: '游戏版本最大长度为 30 个字符', trigger: 'blur'}
                ],
                uri: [
                    {required: true, message: '请填写游戏地址', trigger: 'blur'},
                    {max: 245, message: '游戏地址最大长度为 245 个字符', trigger: 'blur'}
                ],
            },
            codesList: [],//算分码数据
            record: {},
            selectCodeId: '',//选择算分码id
            versionsTit: '',//编辑添加版本弹窗title
            versionId: '',//版本id
            currentId: this.$store.getters["content/getTrainGameInfo"]().id,//当前游戏id
            currentEnabled: this.$store.getters["content/getTrainGameInfo"]().enabled
        };
    },
    watch: {
        isVersions() {
            if (!this.isVersions) {
                this.$refs.ruleForm.resetFields();
            }
        }
    },
    created() {
        // 获取版本数据
        this.getVersion()
        console.log(this.versionsForm);
    },
    methods: {
        // 修改版本状态
        StatusChange(record) {
            this.tableLoading = true;
            this.$http.updateVersionStatus({
                id: record.id,
                enabled: !record.enabled
            }).then(res => {
              record.enabled = !record.enabled
              this.$message.success('修改成功')
              this.getVersion();
            }).catch(() => {
              this.tableLoading = false
            });
        },
        // 添加编辑弹窗确定按钮
        VersionsOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (this.type == 'add') {
                        this.addVersion()
                    } else {
                        this.editVersion()
                    }
                } else {

                }
            })
        },
        // 添加版本
        openModal() {
            this.type = 'add'
            this.versionsTit = '添加版本'
            this.versionsForm = {
                contentId: this.$store.getters["content/getTrainGameInfo"]().id,//当前游戏id
                version: '',//版本号
                uri: '',//地址url
                enabled: false,//状态
                remark: '',//备注
            };
            this.isVersions = true
        },
        // 编辑版本
        editModal(record) {
            this.type = 'edit'
            this.versionsTit = '编辑版本'
            this.isVersions = true
            for (let key in record) {
                for (let k in this.versionsForm) {
                    if (k == key) {
                        this.versionsForm[key] = record[key]
                    }
                }
            }
            this.versionsForm.contentId = this.currentId
            this.versionsForm.id = record.id
        },
        // 获取版本
        getVersion() {
            let params = {
                id: this.currentId
            };
            this.tableLoading = true;
            this.$http.EGamegeVersion(params)
                .then(res => {
                        this.data = res.data.data
                }).finally(() => {
                  this.tableLoading = false;
            });
        },
        // 添加版本
        addVersion() {
            this.$http.addContentVersion(this.versionsForm)
                .then(res => {
                        this.resetForm();
                        this.isVersions = false
                        this.$message.success('添加成功');
                        this.getVersion()
                   
                });
        },
        // 编辑版本
        editVersion() {
            this.$http.updataContentVersion(this.versionsForm)
                .then(res => {
                        this.resetForm();
                        this.isVersions = false
                        this.$message.success('修改成功');
                        this.getVersion()
                  
                });
        },
        // 删除版本
        deleteVersion(record) {
            this.$message.destroy();
            if (record.enabled) {
                this.$message.warning('请先停用该版本');
                return
            }
            let formData = new FormData()
            formData.append('id', record.id)
            this.$http.deleteContentVersion(formData)
                .then(res => {
                        this.$message.success('删除成功');
                        this.getVersion()
                  
                });
        },
        // 获取版本下能力
        getAbility(expanded, record) {
            if (expanded) {
                if (this.expandedRowKeys.length > 1) {
                    this.expandedRowKeys.shift();
                }
                this.record = record
                let params = {
                    ContentVersionId: record.id,
                    ContentId: record.contentId
                };
                this.$http.getAbilityListByVersionId(params).then(res => {
                        this.innerData = res.data.data
                });
            }
        },
        resetForm() {
            this.versionsForm = {
                contentId: this.currentId,
                version: '',
                uri: '',
                status: false,
            }
        }
    }
};
</script>

<style scoped lang="less">
.versionsSet {
    width: 100%;

    h1 {
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
    }

    .btns {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        span {
            font-size: 14px;
        }
    }

    .noClick {
        color: #ccc;
        cursor: default;
    }
}
.table_div{
  display: flex;
  align-items: center;
}
.table_icon{
  color:#ff9904;
  font-size:24px;
  margin-right: 5px;
}
</style>
